import React from "react";
import Modal from "react-modal";
import { Icon } from "@mdi/react";
import { mdiAlertCircle, mdiClose } from "@mdi/js";
import { useTranslation } from "react-i18next";

export default function VideoErrorModal({ isOpen, message, onClose }) {
    const { t } = useTranslation();

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel={t("canvas.videoErrorTitle")}
            className="modalTitle"
            overlayClassName="overlay"
        >
            <div className="title-inputPrimary" style={{ textAlign: "center" }}>
                <div className="title-input">
                    <div className="title-input__label display-flex-center">
                        <Icon path={mdiAlertCircle} size={1.5} color="red" style={{ marginRight: "8px" }} />
                        {t("canvas.videoErrorTitle") || "Video Error"}
                    </div>
                    <div className="title-input__input">
                        <p style={{ marginTop: "15px" }}>{message}</p>
                    </div>
                </div>

                <div className="button" style={{ marginTop: "20px" }}>
                    <button className="button-title" onClick={onClose} style={{ background: "#0A7AAD" }}>
                        <Icon path={mdiClose} size={1} color="white" style={{ marginLeft: "8px" }} />
                        {t("shared.close") || "Close"}
                    </button>
                </div>
            </div>
        </Modal>
    );
}
